const endodontics = {
  hero: {
    badgeIconAlt: "Endodontics Icon",
    badgeText: "Advanced Root Canal Treatments",
    titleLine1: "Modern Endodontic",
    titleLine2: "Care & Treatment",
    description:
      "Our expert endodontic treatments save your natural teeth through advanced, pain-minimized root canal procedures using the latest technology and techniques.",
    ctas: {
      primary: "Schedule Consultation",
      secondary: "Learn About the Process",
    },
    heroImageAlt: "Modern Endodontic Treatment",
    stats: {
      successRateLabel: "Success Rate",
      successRateValue: "95%+",
      painFreeLabel: "Pain-Free",
      painFreeValue: "Advanced",
    },
    experience: {
      label: "Expert Specialists",
      value: "15+ Years Experience",
    },
  },
  benefits: {
    heading: "WHY CHOOSE ENDODONTIC THERAPY",
    intro:
      "Modern root canal therapy preserves your natural teeth with comfort and precision.",
    items: [
      {
        title: "Save Your Natural Teeth",
        description:
          "Endodontic treatment helps you maintain your natural smile, continue enjoying your favorite foods, and limits the need for ongoing dental work.",
      },
      {
        title: "Virtually Pain-Free",
        description:
          "With modern techniques and anesthesia, patients report that root canal treatment is as comfortable as having a filling placed.",
      },
      {
        title: "Efficient & Effective",
        description:
          "Our endodontic procedures are completed in just 1-2 appointments, providing quick relief from pain with excellent long-term outcomes.",
      },
    ],
  },
  process: {
    heading: "OUR TREATMENT PROCESS",
    intro:
      "We follow a precise, methodical approach to ensure the best possible outcomes for our endodontic treatments.",
    steps: [
      {
        title: "Diagnosis & Examination",
        description:
          "Our specialists will take digital x-rays and perform tests to identify the source of your pain and determine if root canal therapy is necessary.",
      },
      {
        title: "Preparation & Anesthesia",
        description:
          "We administer local anesthesia to completely numb the area, ensuring you feel no pain during the procedure.",
      },
      {
        title: "Pulp Removal & Cleaning",
        description:
          "The infected pulp is carefully removed, and the canals are thoroughly cleaned and shaped using specialized instruments.",
      },
      {
        title: "Canal Filling & Sealing",
        description:
          "The cleaned canals are filled with biocompatible material and sealed to prevent reinfection.",
      },
      {
        title: "Final Restoration",
        description:
          "A crown or other restoration is placed to protect the tooth and restore its full function and appearance.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro:
      "Find answers to common questions about endodontic treatments",
    items: [
      {
        question: "Is a root canal painful?",
        answer:
          "With modern techniques and anesthesia, a root canal procedure feels similar to getting a filling. Most patients report being comfortable during the procedure and experiencing only mild discomfort afterward that can be managed with over-the-counter pain medications.",
      },
      {
        question: "How long does a root canal procedure take?",
        answer:
          "Most root canals can be completed in a single appointment lasting 60-90 minutes. More complex cases might require two visits. Our use of advanced technology helps ensure efficiency without compromising quality.",
      },
      {
        question: "How long will a treated tooth last?",
        answer:
          "With proper care, a tooth that has had a root canal can last a lifetime. The success rate of root canal treatment is very high, and many teeth fixed with root canals can last as long as other natural teeth.",
      },
      {
        question: "What happens if I don't get a root canal?",
        answer:
          "If you need a root canal but don't get one, the infection will continue to spread, potentially leading to abscess formation, bone loss, and eventually tooth loss. The infection can also spread to other parts of your body, posing serious health risks.",
      },
      {
        question: "Do I need a crown after a root canal?",
        answer:
          "In most cases, yes. A crown helps protect the treated tooth from fracturing and restores full functionality. Back teeth (molars and premolars) almost always need crowns, while front teeth might not if they're still structurally sound.",
      },
      {
        question: "How do I care for my tooth after a root canal?",
        answer:
          "After your final restoration is placed, you should care for your treated tooth just like your natural teeth: brush twice daily, floss daily, use antimicrobial mouthwash, and visit your dentist regularly for check-ups and cleanings.",
      },
    ],
  },
};

export default endodontics;

